import { Injectable } from '@angular/core';
import { CalculatedCols } from '../../teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { TranslateService } from '@ngx-translate/core';
import { SelectOption } from '../../teiasoft-bucket/teiasoft-select/teiasoft-select.component';
import { BackendService } from '../backend/backend.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridFilter } from '../../teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { withAssetVersion } from '../../utils/asset-version';

@Injectable({
  providedIn: 'root'
})
export class TeiasoftGridService {

  constructor(private translateService: TranslateService, private backendService: BackendService, private httpClient: HttpClient) { }

  /* GENERIC METHOD FOR DATA CALCULATION */
  getCalculatedCol(col: CalculatedCols, data:any):CalculatedCols{
    let _data: string[] = new Array();
    _data = col.method!.split("|");
    if (_data[0] == 'calculateItemsValidity'){
      col.icon = this.calculateItemsValidity(_data[1], data);
      col.tooltip = this.translateService.instant("grid.noItems") + " - " + _data[1];
    }
    
    return col;
  }

  getCalculatedColNoOdata(col: CalculatedCols, data:any):CalculatedCols{
    let _data: string[] = new Array();
    _data = col.method!.split("|");
    if (_data[0] == 'calculateItemsValidity'){
      col.icon = this.calculateItemsValidity(_data[1].substring(0,1).toLowerCase() + _data[1].substring(1,_data[1].length), data);
      col.tooltip = this.translateService.instant("grid.noItems") + " - " + _data[1];
    }
    
    return col;
  }


  /* CALCULATE COLUMNS CUSTOM METHODS */
  calculateItemsValidity(category:string, data: any): string{
    // IF THERE'S NO ITEMS
    if (!data || data.length == 0){
      return 'far fa-unlink gray';
    } else {

      // Special handling for CostsStatus when Validated
      if (category === 'costsStatus' && data[category] === 'Validated') {
        const src = data['costsSource'];
        if (src) {
          if (src === 'CostingToolExactMatch' || src === 'Itdcr' || src === 'ExternalCr') {
            return 'far fa-check-circle green';
          } else {
            return 'far fa-check-circle blue';
          }
        }
        // If no costsSource defined, fall back to default mapping below
      }

      if (data[category] == 'ToBeEvaluated') return 'far fa-question-circle';
      if (data[category] == 'PartiallyValidated') return 'far fa-question-circle';
      if (data[category] == 'Validated') return 'far fa-check-circle green';
      if (data[category] == 'TotallyValidated') return 'far fa-check-circle green';
      if (data[category] == 'NotValid') return 'far fa-times-circle red';
      if (data[category] == 'ItdcrInProgress') return 'far fa-registered purple';
      if (data[category] == 'ItdcrToBeConfirmed') return 'far fa-exclamation-circle yellow';


    }
    return "far fa-bug gray";
  }

  calculateItemsValidityForHome(category:string, data: any): string{
    // IF THERE'S NO ITEMS
    if (!data || data.length == 0){
      return "<i class='far fa-unlink gray mr-5'></i>";
    } else {
      if (data[category] == 'ToBeEvaluated') return "<i class='far fa-question-circle mr-5' title='" + category + ': ' + data[category] + "'></i>";
      if (data[category] == 'PartiallyValidated') return "<i class='far fa-question-circle mr-5' title='" + category + ': ' + data[category] +  "'></i>";
      if (data[category] == 'Validated') return "<i class='far fa-check-circle green mr-5' title='" + category + ': ' + data[category] +  "'></i>";
      if (data[category] == 'NotValid') return "<i class='far fa-times-circle red mr-5' title='" + category + ': ' + data[category] +  "'></i>";
      if (data[category] == 'ItdcrInProgress') return "<i class='far fa-registered purple mr-5' title='" + category + ': ' + data[category] +  "'></i>";
    }
    return "<i class='far fa-bug gray mr-5'></i>";
  }

  /** CHECK IF IS A VALID TIMESTAMP */
  isValidTimestamp(timestamp: number): boolean{
    // Check if it's a valid number
    if (isNaN(timestamp)) {
      return false;
    }
  
    // Check if it's within a reasonable range (e.g., within the past and future)
    const currentTimestamp = Date.now() / 1000; // Convert milliseconds to seconds
    const timestampSeconds = parseInt(timestamp.toString().trimEnd(), 10);
  
    if (timestampSeconds < 0 || timestampSeconds > currentTimestamp + 60 * 60 * 24 * 7) {
      // This example allows timestamps within the next week
      return false;
    }
  
    // Check if the input consists only of digits (and optional minus sign)
    if (!/^-?\d+$/.test(timestamp.toString())) {
      return false;
    }
  
    return true;
  }

  /* CREATE SELECT OPTION LIST */
  createSelectOptionList(column: string): SelectOption[]{
      let _ret: SelectOption[] = new Array();
      /* APPLICABLE NORMS */
      if (column == 'NormGrade'){
       /*  this.backendService.getNormGrades().subscribe(res => {
          if (res && res.normGrades!){
            for (var x=0; x < res.normGrades!.length; x++){
              let _item: SelectOption = new SelectOption();
              _item.text = res.normGrades[x].normGrades[x].;
              _ret.push(_item);
            }
          }
          return _ret;
        }); */
      }

      if (column == 'ApplicationNorms'){
         /* this.backendService.getApplicationNorms().subscribe(res => {
           if (res && res.normGrades!){
             for (var x=0; x < res.normGrades!.length; x++){
               let _item: SelectOption = new SelectOption();
               _item.text = '';
               _item.value = '';
               _ret.push(_item);
             }
           }
           return _ret;
         }); */
       }

      /* RETURN */
      return _ret;
  }

  getFilters(): Observable<GridFilter[]>{
    return this.httpClient.get<GridFilter[]>(withAssetVersion('assets/mock/gridFilters.json'));
  }
}
